// assets
import { IconDashboard, IconUserCheck, IconHeadphones, IconSettings2, IconAffiliate, IconTruck } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

const icons = {
    IconDashboard: IconDashboard,
    IconUserCheck: IconUserCheck,
    IconHeadphones: IconHeadphones,
    IconSettings2: IconSettings2,
    IconAffiliate: IconAffiliate,
    IconTruck: IconTruck
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const inventbill: NavItemType = {
    id: 'settings',
    title: 'Support & Settings',
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'support',
            title: 'Support',
            type: 'item',
            url: '/ticket',
            icon: icons.IconHeadphones,
            breadcrumbs: false
        },
        {
            id: 'verify',
            title: 'Verify KYC',
            type: 'item',
            url: '/customerkyc',
            icon: icons.IconUserCheck,
            breadcrumbs: false
        },
        {
            id: 'label',
            title: 'Label Settings',
            type: 'item',
            url: '/settings/label',
            icon: icons.IconSettings2,
            breadcrumbs: false
        },
        {
            id: 'store',
            title: 'Store Channels',
            type: 'item',
            url: '/connect/store',
            icon: icons.IconAffiliate,
            breadcrumbs: false
        }
    ]
};

export default inventbill;
